import { render } from "./holes.vue?vue&type=template&id=4199ab68"
import script from "./holes.vue?vue&type=script&lang=js"
export * from "./holes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__